import React from "react";
import DeleteGameButton from "./DeleteGameButton";
import "./DangerZone.css";

/**
 * Spec §8.1. The Danger Zone is the only place destructive game-level
 * actions live in v1. Currently just Delete; future expansions belong
 * here, not in the sidebar or split-button caret.
 */
const DangerZone = () => (
  <section className="gx-danger-zone">
    <header className="gx-danger-zone-head">
      <h3 className="gx-danger-zone-title">Danger Zone</h3>
      <p className="gx-danger-zone-sub">
        Permanent actions. There's no undo from here.
      </p>
    </header>
    <div className="gx-danger-zone-actions">
      <DeleteGameButton />
    </div>
  </section>
);

export default DangerZone;
